'use strict';Object.defineProperty(exports,'__esModule',{value:!0});exports.default=function(a){return function(b,c){var d=b?'-'+b:'',e=c?'--'+c:'';return''+a+d+e}};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tab-panel/lib/bemFactory.js
 ** module id = 169
 ** module chunks = 0
 **/